import Vue from 'vue'
import mainVue from './main.vue'
import Cache from './cache'

const defaults = {}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox, cache

const defaultCallback = (action, value) => {
  if (currentBox) {
    let callback = currentBox.callback
    if (typeof callback === 'function') {
      callback(value)
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(value)
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action)
      }
    }
  }
}

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })

  instance.callback = defaultCallback
  instance.cache = cache
}

const showBox = () => {
  if (!instance) {
    initInstance()
  }

  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      let options = currentBox.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }

      let oldCb = instance.callback
      instance.callback = (action, value) => {
        oldCb(action, value)
      }

      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

const QuestionCacheBox = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (typeof options === 'string') {
    options = {
      key: options,
    }
  } else if (options.callback && !callback) {
    callback = options.callback
  }

  if (typeof Promise !== 'undefined') {
    return new Promise((resolve, reject) => { // eslint-disable-line
      currentBox = {
        options: _.merge({}, defaults, QuestionCacheBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject,
      }

      showBox()
    })
  } else {
    currentBox = {
      options: _.merge({}, defaults, QuestionCacheBox.defaults, options),
      callback: callback,
    }

    showBox()
  }
}

QuestionCacheBox.setDefaults = defaults => {
  QuestionCacheBox.defaults = defaults
}

QuestionCacheBox.cache = (name, key, value, options = {}) => {
  if (!cache) {
    cache = new Cache({name, ...options})
  }
  cache.set(key, value)
}

QuestionCacheBox.open = (name, key, options) => {
  if (!cache) {
    cache = new Cache({name, ...options})
  }
  return QuestionCacheBox(_.merge({
    key,
  }, options))
}

QuestionCacheBox.close = () => {
  instance.doClose()
  instance.visible = false
  currentBox = null
}

QuestionCacheBox.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default QuestionCacheBox
export { QuestionCacheBox }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-cache-box/src/main.js